import { buildUrl } from './utils';

const state = {};
const actions = {
  get(context) {
    const url = buildUrl([
      {
        colors: null
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
